import assign from 'lodash/assign'
import capitalize from 'lodash/capitalize'
import clone from 'lodash/clone'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import defaultTo from 'lodash/defaultTo'
import filter from 'lodash/filter'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import forEach from 'lodash/forEach'
import includes from 'lodash/includes'
import indexOf from 'lodash/indexOf'
import isArray from 'lodash/isArray'
import isBoolean from 'lodash/isBoolean'
import isFunction from 'lodash/isFunction'
import isNaN from 'lodash/isNaN'
import isNil from 'lodash/isNil'
import isNumber from 'lodash/isNumber'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'
import join from 'lodash/join'
import map from 'lodash/map'
import max from 'lodash/max'
import maxBy from 'lodash/maxBy'
import merge from 'lodash/merge'
import min from 'lodash/min'
import minBy from 'lodash/minBy'
import parseInt from 'lodash/parseInt'
import pull from 'lodash/pull'
import random from 'lodash/random'
import range from 'lodash/range'
import remove from 'lodash/remove'
import replace from 'lodash/replace'
import reverse from 'lodash/reverse'
import sample from 'lodash/sample'
import some from 'lodash/some'
import sortBy from 'lodash/sortBy'
import split from 'lodash/split'
import take from 'lodash/take'
import times from 'lodash/times'
import toArray from 'lodash/toArray'
import union from 'lodash/union'
import uniq from 'lodash/uniq'
import shuffle from 'lodash/shuffle'
// import merge from 'lodash/merge'
let lo = {
  assign,
  capitalize,
  clone,
  cloneDeep,
  debounce,
  defaultTo,
  filter,
  find,
  findIndex,
  forEach,
  includes,
  indexOf,
  isArray,
  isBoolean,
  isFunction,
  isNaN,
  isNil,
  isNumber,
  isObject,
  isString,
  join,
  map,
  max,
  maxBy,
  merge,
  min,
  minBy,
  parseInt,
  pull,
  random,
  range,
  remove,
  replace,
  reverse,
  sample,
  some,
  sortBy,
  split,
  take,
  times,
  toArray,
  union,
  uniq,
  shuffle,
  //merge,
}

// import * as lodash from 'lodash'
declare var _: any
let l = lo
// Hack to use external variable if available
if (typeof _ !== 'undefined') {
  l = _
}
export { l }
// export const lodash = _
